// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartPageTemplateBreakpoint, cartPageTemplateStyles } from "@conklin/App/Components/Cart/CartPageTemplate";
import { XngStickyWrapper } from "@conklin/App/Components/XngSticky/XngSticky";
import { DivWrapper } from "@conklin/XDL/constants";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

cartPageTemplateStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: minmax(0, 1170px) minmax(0, 376px);
        grid-column-gap: 22px;

        ${xScreen("lte", "lg")} {
            grid-template-columns: minmax(0, 995px) minmax(0, 317px);
        }

        ${xScreen("lte", "md")} {
            grid-template-columns: minmax(0, 50%) minmax(0, 50%);
            grid-column-gap: 20px;
        }

        ${xScreen("lte", cartPageTemplateBreakpoint)} {
            grid-template-columns: minmax(0, 360px) minmax(0, 360px);
        }
        @media print {
            display: block;
            float: left;
        }
    `,
};

cartPageTemplateStyles.headerSection = {
    css: css`
        grid-row: 1 / 2;

        ${xScreen("lte", cartPageTemplateBreakpoint)} {
            grid-column: 1 / 3;
        }
        @media print {
            width: 100%;
        }
    `,
};
cartPageTemplateStyles.titleSection = {
    css: css`
        width: 100%;
        margin-bottom: 18px;
    `,
};
cartPageTemplateStyles.actionsSection = {
    css: css`
        width: 100%;
        margin-bottom: 12px;
    `,
};

cartPageTemplateStyles.mainSection = {
    css: css`
        grid-row: 2 / 3;
        grid-column: 1 / 2;

        ${xScreen("lte", cartPageTemplateBreakpoint)} {
            grid-column: 1 / 3;
            padding: 0;
            margin-top: 0;
            width: 100%;
            margin-bottom: 0;
        }

        @media print {
            float: left;
            display: inline-block;
            margin-right: 22px;
            width: 66.66%;
        }
    `,
};

cartPageTemplateStyles.totalSection = {
    css: css`
        grid-row: 1 / 4;
        grid-column: 2 / 3;
        // XNG-Sticky
        & > ${XngStickyWrapper} > ${DivWrapper} > div:not(:last-child) {
            margin-bottom: 24px;
        }

        ${xScreen("lte", cartPageTemplateBreakpoint)} {
            grid-row: 3 / 3;
            grid-column: 1 / 3;
            display: flex;
            justify-content: center;
            margin-top: 40px;
            width: 100%;

            @media print {
                margin-top: 0;
            }

            & > ${XngStickyWrapper} > ${DivWrapper} {
                height: auto;
            }

            & > ${XngStickyWrapper} {
                max-width: 300px;
            }
        }

        ${xScreen("lte", "sm")} {
            & > ${XngStickyWrapper} {
                max-width: 100%;
            }
        }

        @media print {
            float: right;
            display: inline-block;
            width: calc(33.33% - 22px);
            & > ${XngStickyWrapper} {
                position: static;
            }
        }
    `,
};
cartPageTemplateStyles.cartApproverMessage = {
    css: css`
        &:has(div[class^="Wrapper-sc"]:empty) {
            display: none;
        }
    `,
};
cartPageTemplateStyles.cartFulfullmentSelector = {
    css: css`
        margin-bottom: 24px;
        &:has(div[class^="Wrapper-sc"]:empty) {
            display: none;
        }
    `,
};
cartPageTemplateStyles.xngStickyStyles = {
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};
